<template>
  <li>
    <span v-if="linked" v-html="text"></span>
    <span v-else>{{ item }}</span>
  </li>
</template>

<script>
const props = {
  item: {
    type: String,
    required: true
  }
}

const computed = {
  linked () {
    return this.item.includes('</link>')
  },
  regex () {
    const RE = /<link((?:\/|-|\w|\d| )*)>((\w|\d| )*)<\/link>/g
    return RE.exec(this.item)
  },
  slug () {
    return this.regex[2].toLowerCase().replace(/ /g, '-')
  },
  to () {
    if (this.regex[1].trim() === '/data-dictionary') {
      return '/data-dictionary'
    }
    return '/data-dictionary/#' + this.slug
  },
  text () {
    return this.item.replace(
      this.regex[0],
      `<a id="data-dictionary-link-${this.slug}" href="${this.to}">${this.regex[2]}</a>`
    )
  }
}

export default {
  props,
  computed,
  mounted () {
    if (this.linked === true) {
      const id = `data-dictionary-link-${this.slug}`
      document.getElementById(id).onclick = (e) => {
        e.preventDefault()
        this.$router.push(this.to)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/detail/BulletPoint.vue